import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectMembersInitializationStatus,
} from "../../features/members/members-slice";
import {
  fetchMembers,
  fetchGroups,
} from "../../features/members/slice-extensions/members-slice-extension";

/**
 * Surfaces a failed member-directory load (names would otherwise silently render
 * as "Unknown member") with a one-click retry.
 */
const MemberDirectoryWarning: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const membersInit = useAppSelector(selectMembersInitializationStatus);

  if (membersInit !== "failed") return null;

  return (
    <div className="mt-4 flex items-center gap-3 rounded-lg bg-secondary-95 px-3 py-2 text-sm text-secondary-30 dark:bg-secondary-20 dark:text-secondary-80">
      <span>{t("billing.memberDirectory.warning")}</span>
      <button
        type="button"
        className="btn btn-text shrink-0"
        onClick={() => {
          dispatch(fetchMembers());
          dispatch(fetchGroups());
        }}
      >
        {t("billing.memberDirectory.retry")}
      </button>
    </div>
  );
};

export default MemberDirectoryWarning;
